<p-toast></p-toast>
<p-dialog [visible]="isVisible()" (visibleChange)="close($event)" (onHide)="close(true)" header="Subir resolución"
          [modal]="true" [draggable]="false" [resizable]="false" [closable]="false"
          [style]="{width: '70vw', 'min-width': '500px'}">
    <ng-template pTemplate="content">
        <p-dropdown [(ngModel)]="selectedTypeFile" (onChange)="handleTypeFileSelection($event)"
                    [options]="fileCatalog | async" optionLabel="descripcion" id="templateDropdown" showError
                    [required]=" true"
                    showClear="true" placeholder="Seleccione el tipo de archivo" appendTo="body"
        >
        </p-dropdown>
        <p-message severity="warn"
                   text="Este proceso notifica al usuario que se ha subido un nuevo archivo"></p-message>
        <br/> <br/>
        <p-fileUpload #fileUploader chooseLabel="Seleccionar" chooseIcon="pi pi-upload" uploadLabel="Subir"
                      cancelLabel="Cancelar" accept=".pdf"
                      [maxFileSize]="this.fileUtilsService.maxFileSize"
                      [showUploadButton]="false"
                      [showCancelButton]="false" invalidFileSizeMessageSummary="Tamaño de archivo inválido"
                      invalidFileSizeMessageDetail="El tamaño máximo permitido es 1 MB."
                      invalidFileTypeMessageSummary="Tipo de archivo inválido"
                      invalidFileTypeMessageDetail="Solo se permiten archivos de tipo PDF."
                      (onSelect)="handleFileSelectionToUpload($event)"
                      [disabled]="isUploading()">
            <ng-template pTemplate="empty">
                <div class="flex align-items-center flex-column">
                    <i class="pi pi-cloud-upload border-2 border-circle p-3 text-4xl text-400 border-400"></i>
                    <p class="mt-3 mb-0">Arrastre y suelte el archivo PDF aquí o haga clic en 'Seleccionar'.</p>
                </div>
            </ng-template>
        </p-fileUpload>
        @if (fileForUpload()) {
            <div class="mt-4" style="height: 52vh; overflow-y: hidden;">
                <ng2-pdfjs-viewer [pdfSrc]="fileForUpload()!" [viewerId]="'resolutionPreviewViewer'"
                                  [externalWindow]="false" [download]="false" [print]="false" [openFile]="false"
                                  [viewBookmark]="false"
                                  [fullScreen]="false" [showSpinner]="true" [page]="1" [zoom]="'page-width'">
                </ng2-pdfjs-viewer>
            </div>
        }
    </ng-template>
    <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text p-button-secondary"
                (click)="close(true)" [disabled]="isUploading()"></button>
        <button pButton pRipple type="button" [label]="actionButtonLabel()" icon="pi pi-upload" class="p-button-primary"
                (click)="submitFileForUpload()" [loading]="isUploading()"
                [disabled]="disabledUploadButton()"></button>
    </ng-template>
</p-dialog>
